function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.75581 1.04886C1.85215 1.01693 1.95305 1 2.05556 1H9.94444C10.0469 1 10.1477 1.0169 10.244 1.04878L5.99984 5.29289L1.75581 1.04886ZM1.06197 1.76923C1.02205 1.89165 1 2.02505 1 2.16667V7.83333C1 8.51072 1.50452 9 2.05556 9H9.94444C10.4955 9 11 8.51072 11 7.83333V2.16667C11 2.02496 10.9779 1.89148 10.938 1.769L6.3534 6.35355C6.15814 6.54882 5.84155 6.54882 5.64629 6.35355L1.06197 1.76923ZM2.05556 0C0.888372 0 0 1.0031 0 2.16667V7.83333C0 8.9969 0.888372 10 2.05556 10H9.94444C11.1116 10 12 8.9969 12 7.83333V2.16667C12 1.0031 11.1116 0 9.94444 0H2.05556Z",
  fill: "#157BFA"
});

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email.0e0a20e2.svg";
export { ForwardRef as ReactComponent };